import { action, computed, makeObservable, observable } from 'mobx';

export default class NumberRangePickerState {
  public readonly minValue: number;
  public readonly maxValue: number;
  public readonly step: number;

  @observable
  public min: number;
  @observable
  public max: number;

  public constructor(min: number, max: number, step: number = 1) {
    makeObservable(this);

    this.minValue = min;
    this.maxValue = max;
    this.step = step;
    this.min = min;
    this.max = max;
  }

  @computed
  public get value(): [number, number] {
    return [this.min, this.max];
  }

  @action.bound
  public setValue([min, max]: number[]) {
    this.min = min;
    this.max = max;
  }

  @action.bound
  public setMin(value: number) {
    this.min = Math.min(Math.max(value, this.minValue), this.max);
  }

  @action.bound
  public setMax(value: number) {
    this.max = Math.max(Math.min(value, this.maxValue), this.min);
  }
}
